/*
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：LocalStorageのストア
 *
 * 作成者：2022/1/6 ノア）黄
 * 最終修正者：2022/1/6 ノア）黄
 *
 */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * LocalStorageにデータを設定する
 *
 * @param {string} key キー
 * @param {Record<string, string>} value 値
 * @returns {void}
 */
export function setLocalStorage(key: string, value: any): void {
  localStorage.setItem(key, JSON.stringify(value))
}

/**
 * LocalStorageからデータを取得する
 *
 * @param {string} key キー
 * @returns {void}
 */
export function getLocalStorage(key: string): any {
  if (!localStorage.getItem(key)) {
    return
  }

  return JSON.parse(localStorage.getItem(key) || '{}')
}

/**
 * LocalStorageをクリアする
 *
 * @returns {void}
 */
export function clearLocalStorage(): any {
  localStorage.clear()
}

/**
 * SessionStorageにデータを設定する
 *
 * @param {string} key キー
 * @param {Record<string, string>} value 値
 * @returns {void}
 */
export function setSessionStorage(key: string, value: any): void {
  sessionStorage.setItem(key, JSON.stringify(value))
}

/**
 * SessionStorageからデータを取得する
 *
 * @param {string} key キー
 * @returns {void}
 */
export function getSessionStorage(key: string): any {
  if (!sessionStorage.getItem(key)) {
    return
  }
  return JSON.parse(sessionStorage.getItem(key) || '{}')
}

/**
 * SessionStorageをクリアする
 *
 * @returns {void}
 */
export function clearSessionStorage(): any {
  sessionStorage.clear()
}
